class Contract {
    id = null;
    placement_id = null;
    contract_type_id = null;
    contract_status_id = null;
    user_id = null;
    effective_from = true;
    effective_to = 0;
    expiry_date;
    file = {
        name: '',
        link: '',
        original_name: '',
        upload_id: null,
    };
    properties = {};
    notify_for_extension = null;

    constructor(data, validation = false) {
        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }

        if (validation) {
            for (const [key] of Object.entries(this)) {
                this[key] = true;
            }
        }
    }
}

export default Contract;
